export default "__VITE_ASSET__B2J1RPup__"